import { _ as _define_property } from "@swc/helpers/_/_define_property";
import React from 'react';
import classnames from 'classnames';
import ProgressBar from '../../../ProgressBar';
import LoadingIndicator from '../../../LoadingIndicator';
import s from './UploadThumb.scss';
class UploadThumb extends React.Component {
    componentDidMount() {
        // set the preview of the file currently being uploaded
        const reader = new FileReader();
        reader.onload = (e)=>{
            if (this.preview.current && e.target) {
                this.preview.current.src = e.target.result; // TS3 dom lib is a bit dumb for now
            }
        };
        reader.readAsDataURL(this.props.file);
    }
    render() {
        var _error;
        const { className, progress = 0, error } = this.props;
        return /*#__PURE__*/ React.createElement("div", {
            className: classnames(s['root'], className)
        }, /*#__PURE__*/ React.createElement("img", {
            loading: "lazy",
            className: s['preview'],
            alt: "Upload Preview",
            ref: this.preview
        }), error && /*#__PURE__*/ React.createElement("div", {
            className: s['error']
        }, ((_error = error) === null || _error === void 0 ? void 0 : _error.message) || error.toString()), !error && progress >= 1 && /*#__PURE__*/ React.createElement(LoadingIndicator, {
            className: s['please-wait'],
            spinnerClassName: s['spinner']
        }), !error && /*#__PURE__*/ React.createElement(ProgressBar, {
            className: classnames(s['progress'], progress >= 1 && s['progress-done']),
            barClassName: s['bar'],
            background: "none",
            percentage: progress * 100
        }));
    }
    constructor(...args){
        super(...args);
        _define_property(this, "preview", /*#__PURE__*/ React.createRef());
    }
}
export default UploadThumb;
